import axios from "axios";
import { VoiceOverAd } from "../interfaces/voice-over-ad.interface";


class VoiceOverAdApi {
  // Pass brandId dynamically into the method
  getTracks(): Promise<VoiceOverAd[]> {
    const apiUrl = `/api/v1/voice_over_ads`;

    return axios.get(apiUrl).then((response) => {
      const rawTracks = response?.data?.data || [];
      
      const tracks: VoiceOverAd[] = rawTracks.map((item: any) => ({
        id: item?.id,
        title: item?.attributes?.title || "",
        audioUrl: item?.attributes?.audio_url || "",
        sequence: item?.attributes?.sequence || 0,
      }));

      return tracks.sort((a, b) => a.sequence - b.sequence);
    });
  }
}

export default VoiceOverAdApi;